import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Loader2, Radio, Tv } from "lucide-react";
import { PageHeader } from "@/components/shared/PageHeader";
import { BoardCard } from "@/components/board/BoardCard";
import { api } from "@/lib/api";

const IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/bf3oura7_Novemberka%CC%8Asan%202025-20.webp";

export default function Anslagstavla() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.boardPosts().then((d) => { if (alive) setPosts(d); }).catch(() => { if (alive) setPosts([]); });
    load();
    const t = setInterval(load, 20000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <>
      <PageHeader kicker="Live under tävlingen" title="Anslagstavla" subtitle="Officiell information, PM och uppdateringar publiceras här löpande under Novemberkåsan." image={IMG} />
      <section className="py-14">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          <div className="mb-8 flex flex-wrap items-center justify-between gap-3">
            <div className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-emerald-400">
              <Radio className="w-4 h-4 pulse-dot" /> Uppdateras automatiskt
            </div>
            <Link to="/anslagstavla/live" data-testid="board-live-link" className="inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white hover:border-amber-500 hover:text-amber-500 transition-colors">
              <Tv className="w-4 h-4" /> Storbildsläge
            </Link>
          </div>

          {posts === null && <div className="grid place-items-center py-20"><Loader2 className="w-8 h-8 animate-spin text-amber-500" /></div>}
          {posts && posts.length === 0 && <p className="text-white/40 font-mono text-sm py-10 text-center">Inga anslag ännu. Håll utkik – info publiceras under tävlingen.</p>}
          {posts && posts.length > 0 && (
            <div className="columns-1 sm:columns-2 lg:columns-3 gap-5" data-testid="board-grid">
              {posts.map((p) => <BoardCard key={p.id} post={p} />)}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
